<template>
  <div id="profileBody" class="flexwrap" v-if="profile.datas.unsubscribe==false">

    <settings-card>
      <template v-slot:title>
        Rempli tes infos de profil
      </template>
      <template v-slot:description>
      </template>
      <template v-slot:content>
        <div class="profilecontent flexwrap centercenter">
          <div class="simpleGrid centercenter">
            <div class="fourcolumns">
              <i class="fas fa-female clickable" style="font-size: 3.5em" :style="{color: genderColor(1)}"
                 @click="selectGender(1)"></i>
              <i class="fas fa-male clickable" style="font-size: 3.5em" :style="{color: genderColor(0)}"
                 @click="selectGender(0)"></i>
              <i class="fas fa-dove clickable" style="font-size: 3em" :style="{color: genderColor(2)}"
                 @click="selectGender(2)"></i>
              <i class="fas fa-ban clickable" style="font-size: 2.5em" :style="{color: genderColor(3)}"
                 @click="selectGender(3)"></i>
            </div>
            <div class="fourcolumns">
              <i class="fas fa-birthday-cake" style="font-size: 3em"></i>
              <generic-custom-select :options="daysList" :selectedItem="selectedDay"
                                     name="Day"
                                     :color="'#242012'" @selected="selectDay" id="dayselect"></generic-custom-select>
              <generic-custom-select :options="monthsList" :selectedItem="selectedMonth"
                                     name="Month"
                                     :color="'#555'" @selected="selectMonth" id="monthselect"></generic-custom-select>
              <generic-custom-select :options="Array.from(new Array(100), (x, i) => new Date().getFullYear()-i)" :selectedItem="selectedYear"
                                     name="Year"
                                     :color="'#555'" @selected="selectYear" id="yearselect"></generic-custom-select>

            </div>
            <div class="verticalFlex">
              <h3> <toggle v-model="tempProfile.newsletter_ok">Recevoir la newsletter trimestrielle</toggle></h3>
              <h3> <toggle v-model="tempProfile.child_mode">Afficher seulement les séries tout public</toggle> </h3>
              <h3> <toggle v-model="tempProfile.vulgar_ok">Inclure les mots vulgaires</toggle> </h3>
            </div>
          </div>

          <standard-button id="saveProfileButton" @click="patchUserInfo" :inactive="saveInactive" :color-class="'olive'">Valider</standard-button>
        </div>


      </template>
    </settings-card>





      <div class="paddingRound marginRound flexwrap centercenter clickable mediumShadow mediumRoundAngles"
           style="font-size:0.9em; justify-self: center;  background-color: #162327; color:#eee2c7; position: absolute; bottom: 1vw; right: 1vw;" @click="showUnsubscribePopup=true">Se désinscrire</div>



    <popup  :width="'50vw'" @close="showUnsubscribePopup=false" v-if="showUnsubscribePopup" :key="showUnsubscribePopup">
      <div class="simpleGrid">
      <div style="text-align: center">
        <i class="fas fa-exclamation-triangle"></i>
        Attention, si vous poursuivez la désinscription, toutes les informations relatives à votre compte seront supprimées dans les 48 heures.
        <i class="fas fa-exclamation-triangle"></i>
      </div>
<div></div>
      <div class="bigPaddingRound marginRound flexwrap centercenter clickable mediumShadow mediumRoundAngles"
           style="font-size:0.9em; justify-self: center;  background-color: hsl(350, 95%, 60%); color:hsl(350, 100%, 8%);" @click="unsubscribe">
        <div>Je souhaite bien me désinscrire !</div>

      </div>
      </div>
    </popup>
  </div>
  <div id="profileBody" v-else>
    <div class="flexwrap centercenter">
      Désinscription en cours.
    </div>
    <div class="paddingRound marginRound flexwrap centercenter clickable mediumShadow mediumRoundAngles premium"
         style="font-size:1.1em; margin-bottom: 1vw; justify-self: center;"
         @click="logout">Se déconnecter</div>

  </div>


</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {API_URL} from "@/App";
import {lock} from "@/main";
import axios from "axios";
import Search from "@/components/search";
import SettingsCard from "@/components/settingsCard";

export default {
  name: "profile",
  components: {
    SettingsCard,
    Popup: () => import(/* webpackPrefetch: true */ '@/components/popup.vue'),
    StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue'),
    Toggle: () => import(/* webpackPrefetch: true */ '@/components/toggle.vue'),
    genericCustomSelect: () => import(/* webpackPrefetch: true */ '@/components/genericCustomSelect.vue')
  },

  created() {
    // Gère les changements temporaires (pas encore validées) des infos de l'utilisateur
    this.tempProfile = Object.assign({}, this.profile.datas);
    this.setDate();
  },

  computed: {
    ...mapGetters('global', [
        'isMobile', 'profile',
        'auth0user',
    ])
  },
  watch: {
    'tempProfile.gender':'changedTempProfile',
    'selectedDay':'changedTempProfile',
    'selectedMonth':'changedTempProfile',
    'selectedYear':'changedTempProfile',
    'tempProfile.child_mode':'changedTempProfile',
    'tempProfile.vulgar_ok':'changedTempProfile',
    'tempProfile.newsletter_ok':'changedTempProfile',
    'tempProfile.reminders_ok':'changedTempProfile',
  },
  methods:{
    ...mapActions('global', [
        'set_kidsFilter',
        'update_userDatas',
      'set_closableCardOpened',
    ]),
    changedTempProfile: function() {
      if(this.profile.datas.gender == this.tempProfile.gender &&
          this.getDate().split('T')[0] == this.profile.datas.birth_date.split('T')[0]&&
          this.profile.datas.child_mode == this.tempProfile.child_mode &&
          this.profile.datas.vulgar_ok == this.tempProfile.vulgar_ok &&
          this.profile.datas.newsletter_ok == this.tempProfile.newsletter_ok&&
          this.profile.datas.reminders_ok == this.tempProfile.reminders_ok) {
        this.saveInactive = true
      }
      else{
        this.saveInactive = false
      }

    },
    logout() {
      this.$webAuth.logout({
        returnTo: window.location.origin
      });

    },
    unsubscribe(){
      let payload = {
        "unsubscribe" : true,
      }
      const url = `${API_URL}/api/auth0user/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.patch(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
              .then(response => {this.logout()})
        }
        else {
          console.log(error)
        }
      })
    },
    difficulty: function (difficulty) {
      if (difficulty == 0) {
        return 'A1'
      } else if (difficulty == 1) {
        return 'A2'
      } else if (difficulty == 2) {
        return 'B1'
      } else if (difficulty == 3) {
        return 'B2'
      } else if (difficulty == 4) {
        return 'C1'
      } else {
        return 'C2'
      }
    },

    genderColor: function (gender) {
      if (gender === this.tempProfile.gender) {
        return this.colorGender[gender]
      } else {
        return 'rgba(76,76,76,0.27)';
      }
    },
    gender: function (gender) {
      if (gender == 0) {
        return 'Homme'
      } else if (gender == 1) {
        return 'Femme'
      } else if (gender == 2) {
        return 'Non-binaire'
      } else if (gender == 3) {
        return 'Non-défini'
      } else {
        return ''
      }
    },
    selectGender: function (id) {
      this.tempProfile.gender = id;
    },
    getDate: function() {
      let birthdate = ""
      birthdate += String(new Date().getFullYear()-this.selectedYear)
      birthdate +="-"
      birthdate += String(this.selectedMonth+1).padStart(2, '0')
      birthdate +="-"
      birthdate += String(this.selectedDay+1).padStart(2, '0')
      return birthdate + "T00:00:00+00:00"
    },
    setDate: function() {
      let birthdate = new Date(this.tempProfile.birth_date)
      this.selectYear(new Date().getFullYear()-birthdate.getFullYear())
      this.selectMonth(birthdate.getMonth())
      this.selectDay(birthdate.getDate()-1)
    },
    patchUserInfo() {
      let payload = {
        "birth_date" : this.getDate(),
        "estimated_level":this.tempProfile.estimated_level,
        "gender":this.tempProfile.gender,
        "studying_friday":this.tempProfile.studying_friday,
        "studying_monday":this.tempProfile.studying_monday,
        "studying_saturday":this.tempProfile.studying_saturday,
        "studying_sunday":this.tempProfile.studying_sunday,
        "studying_thursday":this.tempProfile.studying_thursday,
        "studying_tuesday":this.tempProfile.studying_tuesday,
        "studying_wednesday":this.tempProfile.studying_wednesday,
        "reminders_ok":this.tempProfile.reminders_ok,
        "vulgar_ok":this.tempProfile.vulgar_ok,
        "newsletter_ok":this.tempProfile.newsletter_ok,
        "child_mode":this.tempProfile.child_mode,
      }
      const url = `${API_URL}/api/auth0user/`
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.patch(url, payload, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
              .then(response => {
                this.update_userDatas(response.data)
              })
        }
        else {
          console.log(error)
        }
      })
      // On actualise aussi les variables dans le store
      this.saveInactive = true
      this.set_kidsFilter(this.tempProfile.child_mode)
      this.set_closableCardOpened(false)
    },

    selectDay: function (index) {
      this.selectedDay = index;
    },

    selectMonth: function (index) {
      this.selectedMonth = index;
      this.updateDaysList();
    },

    selectYear: function (index) {
      if (index > 0 & index < 100){
        this.selectedYear = index;
      }
      else{
        this.selectedYear = 0;
      }

      this.updateDaysList();
    },
    updateDaysList: function () {
      let nbdays = new Date(2021-this.selectedYear, this.selectedMonth+1, 0).getDate();
      this.daysList = Array.from({length: nbdays}, (x, i) => String(i+1).padStart(2, '0') );
      if(this.selectedDay > this.daysList.length){
        this.selectedDay=0
      }
    }
  },

  data() {
    return {
      saveInactive: true,
      showUnsubscribePopup: false,
      tempProfile: {},
      colorGender: {
        0: "#5670cd",
        1: "#ce3fb1",
        2: "#9331f4",
        3: "#EB3B3B"
      },
      selectedDay: 0,
      selectedMonth: 0,
      selectedYear: 0,
      daysList: [],
      monthsList: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ]
    }
  }
}
</script>

<style scoped>
.profilecontent{
  display: grid;
  width: 50vw;
  max-width: 50vw;
  height: calc(100% - 2vw);
  max-height: calc(100% - 2vw);
  grid-template-rows: auto auto auto 1fr;
  position: relative;
  grid-gap: 1vw;
  padding: 1vw;
}

  #profileBody{
    width: 100%;
    height: 100%;
    justify-content: center;
  }

  #profilePic{
    height: 3.2vw;
    width: 3.2vw;
    background-size: contain;
    border-radius: 2vw;
    border: 0.2vw #3b49a5 solid;
    margin: 0 1vw 0 1vw;
  }

  #blocks{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    grid-gap: 0.9vw;
    width: 50%;
    /*padding: 0.9vw;*/
  }
  .saveProfileButton{
    grid-column: 1/3;
  }

  #date_picker{
    position: absolute;
  }


  .fourcolumns{
    display:grid;
    grid-template-columns: auto auto auto auto;
    grid-template-rows: auto;
    justify-items: center;
    align-items: center;
    grid-gap: 1.5vw;
    width: fit-content;
  }

  .selected{
    background-color: var(--goalBackgroundColor);
    color: var(--goalColor);
  }

  .filter {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-content: center;
    color: #ece2cc;
    padding: 0 0.5vw 0.5vw 0.5vw;
  }

  .filterbuttonselected {
    border: 0.08vw solid #52bbf9;
  }

  #profilebottombuttons{
    margin-bottom: 1vw;
    justify-self: flex-end;
  }

  @media screen and (max-device-width: 767px) {
    .profilecontent{
      width: 90%;
      max-width: 90%;
      height: 80%;
      max-height: 80%;
      position: relative;
    }

    #profileBody{
      width: 100%;
      height: 100%;
      justify-content: center;
    }

    #profilePic{
      height: 10vw;
      width: 10vw;
      border-radius: 6vw;
      border: 0.6vw #3b49a5 solid;
      margin: 3vw 3vw 0 3vw;
    }

    #blocks {
      display: grid;
      grid-template-rows: 1fr 1fr auto;
      grid-template-columns: 1fr;
      grid-gap: 3vw;
      padding: 3vw;
    }

    #saveProfileButton{
      grid-column: 1/2;
    }

    .fourcolumns {
      grid-gap: 3vw;
      max-height: 10vw;
    }


    .filterbuttonp {
      margin-right: 4vw;
      height: 8vw;
      width: 8vw;
      border-radius: 4vw;
      font-size: 0.8em;
      font-weight: bold;
    }

    #calendarcard{
      font-size: 1.1em;
    }

    #profilebottombuttons{
      margin-top: 10vw;
      margin-bottom: 4vw
    }

  }
</style>